// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1kv-4","inputWrap":"styles_inputWrap__1UGJ-","input":"styles_input__SkVCT"};